<script>
// LineChart.js
import { Radar, mixins } from 'vue-chartjs'

export default {
  name: 'RadarChart',
  extends: Radar,
  mixins: [mixins.reactiveProp],

  props: {
    options: {
      type: Object,
      default: function () {
        return {
          responsive: true,
          maintainAspectRatio: true,
          scaleOverride: true,
          scaleBeginAtZero: true,
          layout: {
            padding: {
              left: 50,
              right: 50,
              top: 50,
              bottom: 50
            }
          },
          scale: {
            display: true,
            ticks: {
              beginAtZero: true,
              min: 0,
              max: 100,
              stepSize: 20,
              callback: function (value, index, values) {
                return value + '%'
              }
            },
            pointLabels: {
              fontSize: 16
            }
          },
          tooltips: {
            callbacks: {
              label: function (tooltipItem, data) {
                var label = data.datasets[tooltipItem.datasetIndex].label || ''

                if (label) {
                  label += ': '
                }
                var val = tooltipItem.yLabel
                return parseFloat(val) ? label + val + '%' : label + 'n/a'
              }
            }
          },
          legend: {
            padding: 10,
            position: 'bottom',
            labels: {
              fontSize: 16
            }
          },
          defaultFontSize: 16,
          animation: {
            duration: 0
          }
        }
      }
    },
    labelsValues: { type: Boolean, default: true }
  },

  data: () => ({
  }),

  watch: {
    labelsValues: function (n, o) {
      this.update()
    }
  },

  mounted () {
    this.addPlugin(
      {
        id: 'renderHooks',
        afterRender: function (obj) {
          if (obj.options.callback) {
            obj.options.callback()
            obj.options.callback = null // be sure it won't be called again
          }
        },
        afterDraw (obj) {
          if (obj.options.labelsValues) {
            var ctx = obj.chart.ctx
            ctx.font = '12px Arial'
            ctx.textAlign = 'center'
            var nDatasets = obj.data.datasets.length
            var center = [obj.chart.scale.xCenter, obj.chart.scale.yCenter]
            var length = obj.scale.pointLabels.length
            var half = length / 2
            for (var i = 0; i < length; i++) {
              // get the point position
              var pointLabelPosition = obj.scale.getPointPosition(i, obj.scale.getDistanceFromCenterForValue(100) + 5) // 100 for 100%, max value
              var width = obj.chart.scale._pointLabelSizes[i].w
              var height = obj.chart.scale._pointLabelSizes[i].h

              if (pointLabelPosition.y > center[1]) { pointLabelPosition.y += 1.5 * height } else { pointLabelPosition.y -= 2 * height }

              if (!(i < 1e-2 || Math.abs(i - half) < 1e-2)) {
                if (i > half) {
                  pointLabelPosition.x -= width / 2
                } else {
                  pointLabelPosition.x += width / 2
                }
              }

              var texts = []
              var colors = []
              for (var n = 0; n < nDatasets; n++) {
                var dataset = obj.data.datasets[n]
                if (dataset.data[i] != null) { texts.push(dataset.data[i] + '%') } else { texts.push('n/a') }
              }
              ctx.fillStyle = 'rgba(100, 100, 100, 255)'
              ctx.fillText(texts.join('  '), pointLabelPosition.x, pointLabelPosition.y)
            }
          }
        }
      }
    )
    this.update()
  },

  methods: {
    update (callback = null) {
      this.options.labelsValues = this.labelsValues
      var opt = Object.assign({}, this.options) // clone options
      opt.callback = callback // decorate with potential callback for pdf or word creation
      this.renderChart(this.chartData, opt) // render
    }
  }
}
</script>



// WEBPACK FOOTER //
// ../../../../resources/js/components/RadarChart.vue